<template>
	<sideNav :page-title="pageTitle"></sideNav>
	<div class="ld-panel-title">
		<h2 class="back-btn">常用地址管理</h2>
	</div>
	<div class="ld-panel-main">
		<div class="head-operate">
			<el-button type="primary" @click="dialogGroupVisible = true">新增地址</el-button>
			<el-alert title="常用地址最多可添加至5个!" type="warning" show-icon :closable="false" style=" width: 260px; float: right;" />
		</div>
		<el-table :data="tableData" style="width: 100%">
		    <el-table-column prop="contact_name" label="联系人姓名" width="180" />
		    <el-table-column prop="contact_phone" label="手机号码" width="180" />
		    <el-table-column prop="detail" label="地址" />
			<el-table-column prop="postal_code" label="邮编" width="100" />
			<el-table-column prop="isDefault" label="设为默认" width="100">
				<template #default="scope">
					<el-switch v-model="scope.row.isDefault" @change="defaultChange(scope.row)" />
				</template>
			</el-table-column>
			<el-table-column label="操作" width="120">
			  <template #default="scope">
				<el-button link type="primary" @click="handleEdit(scope.row.id)">修改</el-button>
				<el-button link type="danger" @click="handleDelete(scope.row)">删除</el-button>
			  </template>
			</el-table-column>
		</el-table>
	</div>
	<!-- 常用地址 -->
	<el-dialog width="800" :show-close="false" :close-on-click-modal="false" v-model="dialogGroupVisible" title="常用地址">
		<el-form :rules="rules" ref="ruleFormRef" :model="groupForm" :label-width="formLabelWidth">
			<el-form-item label="联系人姓名" prop="contact_name">
				<el-input v-model="groupForm.contact_name" autocomplete="off" />
			</el-form-item>
			<el-form-item label="所在地区" prop="province">
				<area-picker :areaData="areaData" @prvChange="prvChange" @cityChange="cityChange" @districtChange="districtChange" />
			</el-form-item>
			<el-form-item label="街道地址" prop="street">
				<el-input v-model="groupForm.street" autocomplete="off" />
			</el-form-item>
			<el-form-item label="手机号码" prop="contact_phone">
				<el-input v-model="groupForm.contact_phone" autocomplete="off" />
			</el-form-item>
			<el-form-item label="邮政编码" prop="postal_code">
				<el-input v-model="groupForm.postal_code" autocomplete="off" />
			</el-form-item>
		</el-form>
		<template #footer>
			<span class="dialog-footer">
				<el-button @click="resetForm(ruleFormRef)">取消</el-button>
				<el-button type="primary" @click="submitForm(ruleFormRef)">提交</el-button>
			</span>
		</template>
	</el-dialog>
</template>

<script setup>
	import { ref,reactive,nextTick,onMounted} from 'vue';
	import sideNav from '../../components/sideNav.vue';
	import tableList from '../../components/tableList.vue';
	import areaPicker from '../../components/areaPicker.vue';
	import { getAddress,addressSave,addressDel,addressDefault,addressInfo } from '@/api/account';
	import { ElMessage, ElMessageBox } from 'element-plus';
	
	const pageTitle = 'account';
	const loading = ref(false);
	const dialogGroupVisible = ref(false);
	const formLabelWidth = ref('160px');
	const prvObj = ref('');
	const cityObj = ref('');
	const districtObj = ref('');
	const prvId = ref(0);
	const cityId = ref(0);
	const districtId = ref(0);
	const prv = ref('');
	const city = ref('');
	const district = ref('');
	const areaData = ref([]);
	const tableData = ref();
	const ruleFormRef = ref(null);
	const groupForm = ref({contact_name:'',street:'',contact_phone:'',postal_code:''});
	const rules = reactive({
		contact_name: [
			{ required: true, message: '请填写联系人姓名', trigger: 'blur' }
		],
		street: [
			{ required: true, message: '请填写街道地址', trigger: 'blur' }
		],
		contact_phone: [
			{ required: true, message: '请填写手机号码', trigger: 'blur' }
		]
	});
	
	const fetchListF = () => {
		getAddress().then((res) => {
			tableData.value = res.data;
			loading.value = false;
		})
	};
	const handleEdit = (val) => {
		addressInfo(val).then((res) => {
			if(res.code === 200){
				groupForm.value = res.data;
				prvId.value = res.data.province;
				cityId.value = res.data.city;
				districtId.value = res.data.area;
				prv.value = res.data.provinceText;
				city.value = res.data.cityText;
				district.value = res.data.areaText;
				dialogGroupVisible.value = !dialogGroupVisible.value
				nextTick(() => {
				    if (res.data.province !== 0) {
				    	areaData.value.push(
				    		{ key: res.data.province.toString(), value: res.data.provinceText },
				    		{ key: res.data.city.toString(), value: res.data.cityText },
				    		{ key: res.data.area.toString(), value: res.data.areaText }
				    	);
				    }
				})
			}
		});
	};
	const handleDelete  = (row) => {
		const param = {"id": row.id};
		ElMessageBox.confirm(
			'确认要删除该数据吗？',
			'提示',
			{
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				showClose:false,
				type: 'warning',
			}
		)
		.then(() => {
			addressDel(param).then((res) => {
				ElMessage({
					offset:70,
					message: res.msg,
					type: 'success'
				})
				fetchListF()
			})
		})
		.catch(() => {
			
		})
	};
	const defaultChange = (row) => {
		const param = {'id':row.id};
		addressDefault(param).then((res) => {
			if(res.code === 200){
				ElMessage({
					offset:70,
					message: res.msg,
					type: 'success'
				})
				fetchListF()
			}
		});
	};
	const prvChange = (val) =>{
		prvObj.value = val
	};
	const cityChange = (val) =>{
		cityObj.value = val
	};
	const districtChange = (val) =>{
		districtObj.value = val
	};
	const submitForm = () => {
		if (!ruleFormRef.value) return;
		ruleFormRef.value.validate((valid) => {
			if (valid) {
				const param = groupForm.value;
				param['province'] = prvObj.value == '' ? prvId.value : parseInt(prvObj.value.key);
				param['city'] = cityObj.value == '' ? cityId.value : parseInt(cityObj.value.key);
				param['area'] = districtObj.value == '' ? districtId.value : parseInt(districtObj.value.key);
				param['province_text'] = prvObj.value == '' ? prv.value : prvObj.value.value;
				param['city_text'] = cityObj.value == '' ? city.value : cityObj.value.value;
				param['area_text'] = districtObj.value == '' ? district.value : districtObj.value.value;
				addressSave(param).then((res) => {
					if(res.code === 200){
						ElMessage({
							offset:70,
							message: res.msg,
							type: 'success'
						})
						resetForm()
						fetchListF();
					}
				})
			} else {
			  return false;
			}
		});
	};
	const resetForm = () => {
		location.reload()
	}
	
	
	onMounted(() => {
		fetchListF();
	});
	
</script>

<style lang="scss">
	.cascader{
		.el-select{
			float: left;
			width: 170px !important;
			margin-right: 10px;
		}
		.el-select:first-child{width: 120px !important;}
	}
</style>